<template>
    <section class="form-page tw-pt-6 lg:tw-pt-10">
        <Form v-if="!$store.state.formSuccess" />
        <FormSuccess v-if="$store.state.formSuccess" >
            Thank you message
        </FormSuccess>
    </section>
</template>

<script>
import Terms from '@/components/Terms.vue';
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Proposition',
    components: {
        Terms,
        Form,
        FormSuccess,
    },
}
</script>